import api from './axiosConfig';
import { handleApiError } from './errorHandler';

export const brandAPI = {
    create: async (brandData) => {
        try {
            const { data } = await api.post('/api/brands/create/', brandData);
            return data;
        } catch (error) {
            handleApiError(error, 'Create brand error:');
        }
    },
    getAll: async (page, pageSize, searchTerm, showDeactivated) => {
        try {
            const { data } = await api.get('/api/brands', {
                params: { page, pageSize, searchTerm, showDeactivated }
            });
            return data;
        } catch (error) {
            handleApiError(error, 'Get all brands error:');
        }
    },
    getById: async (id) => {
        try {
            const { data } = await api.get(`/api/brands/${id}`);
            return data;
        } catch (error) {
            handleApiError(error, 'Get brand by id error:');
        }
    },
    update: async (id, brandData) => {
        try {
            const { data } = await api.put(`/api/brands/update/${id}/`, brandData);
            return data;
        } catch (error) {
            handleApiError(error, 'Update brand error:');
        }
    },
    delete: async (id) => {
        try {
            const { data } = await api.delete(`/api/brands/delete/${id}/`);
            return data;
        } catch (error) {
            handleApiError(error, 'Delete brand error:');
        }
    }
};
